export const TABS = {
  ACCOUNT: 'Account',
  ASSET: 'Asset',
  SCHEDULE: 'Schedule',
  SESSION: 'Session',
  ROLE: 'Role',
  ENTITLEMENTS: 'Entitlements',
};

export const TITLES = {
  SUMMARY: 'Summary',
  SYSTEM_DETAILS: 'System Details',
  TIME: 'Time',
  ACCOUNT: 'Account',
  REQUEST_DETAILS: 'Request Details',
  COMMENTS: 'Comments',
  ATTACHMENTS: 'Attachments',
  TARGET_SYSTEM: 'Target System',
  REMOTE_APPLICATION: 'Remote Application',
  SAP_TRANSACTION_CODES: 'SAP Transaction Codes',
  CUSTOM_PROPERTIES: 'Custom Properties',
  SECURITY_RANKINGS: 'Security Rankings',
};

export const TYPES = {
  ACCOUNT: 'account',
  SESSION: 'session',
  ENDPOINT: 'endpoint',
  ROLE: 'role',
};

export const ASSET_TYPES = {
  ACCOUNT: 'Account',
  APPLICATION: 'Application',
  DATABASE: 'Database',
  SERVER: 'Server',
  CONSOLE: 'Console',
  ROLE: 'Role',
};

export const CLOUD_PROVIDERS = {
  AWS: 'AWS',
  AZURE: 'AZURE',
  GCP: 'GCP',
};

export const PLATFORMS_LABELS = {
  AWS_ACCOUNT: 'AWS Account',
  AZURE_SUBSCRIPTION: 'Azure Subscription',
  GCP_PROJECT: 'GCP Project',
};

export const TENANTS_LABELS = {
  TENANT_AWS: 'Tenant (AWS Account)',
  TENANT_AZURE: 'Tenant (Azure Account)',
  TENANT_GCP: 'Tenant (GCP Account)',
};

export const BUTTON_LABELS = {
  CHECK_IN: 'Check In',
  EXTEND: 'Extend',
  // TODO: Remove after getting requirements for Credentialless
  CHECKOUT_CREDENTIAL: 'Check Out Credential',
  CHECKOUT_CREDENTIALS: 'Check Out Credentials',
  CONNECT_TO_SESSION: 'Connect to Session',
  CANCEL_REQUEST: 'Cancel Request',
  END: 'End',
  CANCEL_SESSION: 'Cancel Session',
  LAUNCH_SESSION: 'Launch Session',
  EXTEND_SESSION: 'Extend Session',
  END_SESSION: 'End Session',
  CHECKOUT_ROLE: 'Check Out Role',
  SHOW_ALL: 'Show All',
  VIEW_DETAILS: 'View Details',
  CANCEL: 'Cancel',
};

export const LABELS = {
  NAME: 'Name',
  PLATFORM: 'Platform',
  DESCRIPTION: 'Description',
  LOCATION: 'Location',
  ACCOUNT_TYPE: 'Account Type',
  AUTHENTICATION_MECHANISM: 'Authentication Mechanism',
  ID: 'ID',
  OPERATING_SYSTEM: 'Operating System',
  ENVIRONMENT: 'Environment',
  NETWORK: 'Network',
  DATABASE_NAME: 'Database Name',
  INSTANCE: 'Instance',
  INSTANCE_OS: 'Instance (OS)',
  RDS_TYPE: 'RDS Type',
  PUBLIC_IP: 'Public IP',
  PRIVATE_IP: 'Private IP',
  START_TIME: 'Start Time',
  END_TIME: 'End Time',
  REQUEST_STATUS: 'Request Status',
  REQUEST_ID: 'Request ID',
  REQUEST_TIME: 'Request Time',
  ASSIGNED_TO: 'Assigned to',
  TICKET_NUMBER: 'Ticket Number',
  JUSTIFICATION: 'Justification',
  T_CODES_SELECTED: 'T-Codes Selected',
  APPROVED_BY: 'Approved By',
  APPROVAL_TIME: 'Approval Time',
  TARGET_SERVER: 'Target Server',
  PORT_NUMBER: 'Port Number',
  DATABASE_TYPE: 'Database Type',
  IP_HOST: 'IP/HOST',
  RISK: 'Risk',
  SOX_CRITICAL: 'Sox Critical',
  SYS_CRITICAL: 'Sys Critical',
  PRIVILEGED: 'Privileged',
  CONFIDENTIALITY: 'Confidentiality',
  PENDING_APPROVAL: 'Pending Approval',
};

export const SECURITY_RANKINGS_LABELS = {
  VERY_LOW: 'Very Low',
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  CRITICAL: 'Critical',
};

export const PAM_PLATFORM_TYPES = {
  UNIX: 'unix',
  WINDOWS: 'windows',
  DB: 'db',
  AD_CONSOLE: 'adconsole',
  GCP_CONSOLE: 'gcpconsole',
};
export const PAM_PLATFORM_BY_CONSOLE = {
  AD_CONSOLE: 'adconsole',
  GCP_CONSOLE: 'gcpconsole',
};
